import { CaretLeft, Check } from "@phosphor-icons/react"
import { Button } from "@tokenterminal/core/ui/button/Button"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { Input } from "@tokenterminal/ui/InputV3"
import { useState } from "react"
import ActionItem from "./ActionItem"
import OrganizationDetails from "./OrganizationDetails"

const LIMIT = 7

type AccountSwitcherViewProps = {
  organizations: {
    id: string
    name: string
    logo_url: string | null
  }[]
  handleBack: () => void
  handleSetActiveOrganization: (id: string) => void
  activeOrganizationId?: string
}

const AccountSwitcherView = ({
  organizations,
  handleBack,
  handleSetActiveOrganization,
  activeOrganizationId,
}: AccountSwitcherViewProps) => {
  const [searchText, setSearchText] = useState("")

  const filteredOrganizations = organizations.filter((org) => {
    if (!searchText) return true

    return org.name.toLowerCase().includes(searchText.toLowerCase())
  })

  return (
    <div className="flex flex-col p-2 gap-2">
      <div className="flex flex-col gap-2">
        <Button
          onPress={handleBack}
          variant="ghost"
          size="small"
          className="self-start !text-xs !p-2 !rounded-[6px]"
        >
          <Icon as={CaretLeft} />
          Back
        </Button>
        <h5 className="text-sm font-medium pl-2">Switch account</h5>
        {organizations.length > LIMIT && (
          <Input
            variant="ghost"
            placeholder="Search"
            value={searchText}
            autoFocus
            onChange={(e) => setSearchText(e.target.value)}
          />
        )}
      </div>
      <div
        className="flex flex-col gap-0 with-overflow"
        style={{
          // Hardcoded to cut off at 7.5 items
          maxHeight: "322px",
        }}
      >
        {filteredOrganizations.length > 0 ? (
          filteredOrganizations.map((org) => (
            <ActionItem
              key={org.id}
              item={{
                label: (
                  <OrganizationDetails logoUrl={org.logo_url} name={org.name} />
                ),
                onClick: () => {
                  handleSetActiveOrganization(org.id)
                  handleBack()
                },
                icon: org.id === activeOrganizationId ? Check : undefined,
              }}
            />
          ))
        ) : (
          <div className="flex flex-col justify-center items-center gap-2">
            <div className="text-sm text-fg-secondary">
              No organizations found
            </div>
          </div>
        )}
      </div>
      {/* <Divider variant="secondary" /> */}
      {/* <ActionItem
        item={{
          label: "Create team",
          onClick: () => window.alert("Create team"),
          icon: PlusCircle,
        }}
      /> */}
    </div>
  )
}

export default AccountSwitcherView
